<ng-container *ngIf="showShell">
  <button *ngIf="showFab" type="button" class="unread-fab" (click)="toggle()"
    [attr.aria-label]="mobileOpen ? 'Close unread coaching chats' : 'Open unread coaching chats'"
    [attr.aria-expanded]="mobileOpen">
    <i class="bi bi-inbox-fill"></i>
    <span class="badge" *ngIf="!mobileOpen && unreadTotal > 0">{{ unreadTotal > 99 ? '99+' : unreadTotal }}</span>
  </button>

  <button *ngIf="showStrip" type="button" class="unread-strip" (click)="toggle()"
    aria-label="Open unread coaching chats">
    <i class="bi bi-inbox-fill"></i>
    <span class="strip-label">Unread</span>
    <span class="badge" *ngIf="unreadTotal > 0">{{ unreadTotal > 99 ? '99+' : unreadTotal }}</span>
  </button>

  <aside class="unread-dock" *ngIf="showPanel" [class.mobile]="isMobile" [class.desktop]="!isMobile"
    aria-label="Unread coaching conversations">
    <header class="dock-head">
      <div>
        <h3>Unread chats</h3>
        <p>{{ threads.length ? threads.length + ' waiting' : 'All caught up' }}</p>
      </div>
      <div class="actions">
        <button type="button" class="icon-btn" (click)="refresh()" [disabled]="loading" aria-label="Refresh" title="Refresh">
          <i class="bi bi-arrow-clockwise" [class.spin]="loading"></i>
        </button>
        <button type="button" class="icon-btn" (click)="close()"
          [attr.aria-label]="isMobile ? 'Close' : 'Collapse'">
          <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile"></i>
        </button>
      </div>
    </header>

    <div class="dock-body">
      <p class="empty" *ngIf="!loading && !threads.length">No unread client messages.</p>
      <button type="button" class="row" *ngFor="let t of threads; trackBy: trackById"
        (click)="openThread(t.thread_id)">
        <span class="avatar">
          <img *ngIf="t.assignment.user?.picture_url" [src]="t.assignment.user?.picture_url" alt="" />
          <span *ngIf="!t.assignment.user?.picture_url">{{ initials(t.assignment.user) }}</span>
        </span>
        <span class="main">
          <span class="name">{{ t.assignment.user?.name || 'Unknown' }}</span>
          <span class="preview">{{ t.last_message?.content || 'New message' }}</span>
          <span class="meta">{{ productLineLabel(t.assignment.product_line) }}</span>
        </span>
        <span class="badge-unread" *ngIf="t.unread_count">{{ t.unread_count }}</span>
      </button>
    </div>
  </aside>

  <div class="unread-backdrop" *ngIf="isMobile && mobileOpen" (click)="close()" aria-hidden="true"></div>
</ng-container>
